module.exports = __webpack_public_path__ + "b1c80ba237656ed92c89398e11d80f3f.MP3";